function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M93.13 18.01a.25.25 0 000-.353l-1.59-1.59a.25.25 0 00-.354.353l1.414 1.414-1.414 1.414a.25.25 0 00.354.354l1.59-1.591zm-56.759.074h2.02v-.5h-2.02v.5zm6.063 0h4.041v-.5h-4.041v.5zm8.083 0h4.041v-.5h-4.041v.5zm8.083 0h4.042v-.5H58.6v.5zm8.083 0h4.042v-.5h-4.042v.5zm8.084 0h4.041v-.5h-4.041v.5zm8.083 0h4.042v-.5H82.85v.5zm8.083 0h2.021v-.5h-2.02v.5z",
  fill: "#BFC0C7"
});
var _ref2 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.2,
  filter: "url(#auto-generated-connections_svg__filter0_d_4066_313789)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 100.359,
  y: 3.925,
  width: 35,
  height: 8.5,
  rx: 1,
  fill: "#fff",
  shapeRendering: "crispEdges"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107.455,
  cy: 8.175,
  r: 3.135,
  fill: "#D0DADB"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107.488,
  cy: 8.174,
  r: 1.875,
  fill: "#E4E7EC"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M106.684 9.099l1.094.925a1.88 1.88 0 001.488-1.246l-1.464-1.464-.95 1.785h-.168z",
  fill: "#D4DAE1"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M107.7 8.192a.749.749 0 00.205-.496c0-.272-.097-.49-.423-.49-.327 0-.424.218-.424.49 0 .175.085.381.206.496-.26.06-.513.266-.604.786-.03.164.121.164.121.164h1.401c.006 0 .152 0 .121-.164-.084-.52-.343-.726-.603-.786z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107.457,
  cy: 7.736,
  r: 0.531,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  x: 113.59,
  y: 7.021,
  width: 13.757,
  height: 2.307,
  rx: 1,
  fill: "#EDEEF2"
}));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#auto-generated-connections_svg__filter1_d_4066_313789)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 100.09,
  y: 3.925,
  width: 35,
  height: 8.5,
  rx: 1,
  fill: "#FAFAFA",
  shapeRendering: "crispEdges"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107.185,
  cy: 8.175,
  r: 3.135,
  fill: "#D4D7D9"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107.215,
  cy: 8.174,
  r: 1.875,
  fill: "#E4E7EC"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M106.41 9.099l1.094.925a1.878 1.878 0 001.488-1.246l-1.463-1.464-.95 1.785h-.169z",
  fill: "#D4DAE1"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M107.426 8.192a.75.75 0 00.206-.496c0-.272-.097-.49-.424-.49-.326 0-.423.218-.423.49 0 .175.085.381.206.496-.26.06-.513.266-.604.786-.03.164.121.164.121.164h1.401c.006 0 .151 0 .121-.164-.085-.52-.344-.726-.604-.786z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107.184,
  cy: 7.736,
  r: 0.531,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  x: 113.32,
  y: 7.021,
  width: 13.757,
  height: 2.307,
  rx: 1,
  fill: "#EDEEF2"
}));
var _ref4 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5,
  filter: "url(#auto-generated-connections_svg__filter2_d_4066_313789)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 100.09,
  y: 13.425,
  width: 35,
  height: 8.5,
  rx: 1,
  fill: "#fff",
  shapeRendering: "crispEdges"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107.185,
  cy: 17.675,
  r: 3.135,
  fill: "#89A2A5"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107.215,
  cy: 17.674,
  r: 1.875,
  fill: "#E4E7EC"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M106.41 18.599l1.094.925a1.878 1.878 0 001.488-1.246l-1.463-1.463-.95 1.784h-.169z",
  fill: "#D4DAE1"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M107.426 17.692a.75.75 0 00.206-.496c0-.272-.097-.49-.424-.49-.326 0-.423.218-.423.49 0 .175.085.381.206.496-.26.06-.513.266-.604.786-.03.163.121.163.121.163h1.401c.006 0 .151 0 .121-.163-.085-.52-.344-.726-.604-.786z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107.184,
  cy: 17.236,
  r: 0.531,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  x: 113.32,
  y: 16.521,
  width: 13.757,
  height: 2.307,
  rx: 1,
  fill: "#EDEEF2"
}));
var _ref5 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#auto-generated-connections_svg__filter3_d_4066_313789)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 100.359,
  y: 22.925,
  width: 35,
  height: 8.5,
  rx: 1,
  fill: "#FAFAFA",
  shapeRendering: "crispEdges"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107.455,
  cy: 27.175,
  r: 3.135,
  fill: "#D4D7D9"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107.488,
  cy: 27.174,
  r: 1.875,
  fill: "#E4E7EC"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M106.684 28.099l1.094.925a1.88 1.88 0 001.488-1.246l-1.464-1.463-.95 1.784h-.168z",
  fill: "#D4DAE1"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M107.7 27.192a.748.748 0 00.205-.496c0-.272-.097-.49-.423-.49-.327 0-.424.218-.424.49 0 .175.085.381.206.496-.26.06-.513.266-.604.786-.03.163.121.163.121.163h1.401c.006 0 .152 0 .121-.163-.084-.52-.343-.726-.603-.786z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107.457,
  cy: 26.736,
  r: 0.531,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  x: 113.59,
  y: 26.021,
  width: 13.757,
  height: 2.307,
  rx: 1,
  fill: "#EDEEF2"
}));
var _ref6 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#auto-generated-connections_svg__filter4_d_4066_313789)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 95.359,
  y: 17.77,
  width: 45,
  height: 10.929,
  rx: 1.286,
  fill: "#fff",
  shapeRendering: "crispEdges"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104.479,
  cy: 23.233,
  r: 4.03,
  fill: "#1A2172"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104.524,
  cy: 23.232,
  r: 2.411,
  fill: "#E4E7EC"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M103.492 24.422l1.407 1.19a2.415 2.415 0 001.913-1.602l-1.882-1.882-1.221 2.294h-.217z",
  fill: "#D4DAE1"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M104.795 23.256a.966.966 0 00.264-.638c0-.35-.124-.63-.544-.63-.42 0-.545.28-.545.63 0 .226.109.49.265.638-.335.078-.66.342-.777 1.01-.039.21.156.21.156.21h1.801c.008 0 .195 0 .156-.21-.109-.668-.442-.932-.776-1.01z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104.484,
  cy: 22.669,
  r: 0.683,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  x: 112.367,
  y: 21.75,
  width: 17.687,
  height: 2.967,
  rx: 1.286,
  fill: "#EDEEF2"
}));
var _ref7 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#auto-generated-connections_svg__filter5_d_4066_313789)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 95.359,
  y: 5.888,
  width: 45,
  height: 10.929,
  rx: 1.286,
  fill: "#fff",
  shapeRendering: "crispEdges"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104.479,
  cy: 11.352,
  r: 4.03,
  fill: "#FFB77C"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104.524,
  cy: 11.351,
  r: 2.411,
  fill: "#E4E7EC"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M103.492 12.541l1.407 1.19a2.415 2.415 0 001.913-1.602l-1.882-1.882-1.221 2.294h-.217z",
  fill: "#D4DAE1"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M104.795 11.375a.966.966 0 00.264-.638c0-.35-.124-.63-.544-.63-.42 0-.545.28-.545.63 0 .226.109.49.265.638-.335.078-.66.342-.777 1.01-.039.21.156.21.156.21h1.801c.008 0 .195 0 .156-.21-.109-.668-.442-.932-.776-1.01z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104.484,
  cy: 10.789,
  r: 0.683,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  x: 112.367,
  y: 9.869,
  width: 17.687,
  height: 2.967,
  rx: 1.286,
  fill: "#EDEEF2"
}));
var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 119.353,
  cy: 17.516,
  r: 4.408,
  fill: "#0E72ED"
});
var _ref9 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#auto-generated-connections_svg__clip0_4066_313789)",
  fill: "#BFC0C7"
}, /*#__PURE__*/React.createElement("path", {
  d: "M120.908 16.983l-.231.23a.253.253 0 11-.358-.358l.231-.23a.454.454 0 000-.642.464.464 0 00-.641 0l-.945.945a.45.45 0 000 .642.253.253 0 11-.358.358.953.953 0 01-.282-.68c0-.256.1-.497.282-.679l.945-.944a.96.96 0 011.357 1.358z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M119.413 16.76a.253.253 0 000 .358.45.45 0 010 .642l-.945.945a.454.454 0 01-.642-.642l.232-.231a.255.255 0 000-.359.255.255 0 00-.359 0l-.231.232a.962.962 0 00.679 1.638.957.957 0 00.679-.28l.945-.945a.955.955 0 00.281-.68c0-.256-.1-.497-.281-.678a.253.253 0 00-.358 0z"
}));
var _ref10 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#auto-generated-connections_svg__filter6_d_4066_313789)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 19,
  y: 9.425,
  width: 35,
  height: 8.5,
  rx: 1,
  fill: "#fff",
  shapeRendering: "crispEdges"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 26.096,
  cy: 13.675,
  r: 3.135,
  fill: "#D4D7D9"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 26.129,
  cy: 13.674,
  r: 1.875,
  fill: "#E4E7EC"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25.324 14.599l1.094.925a1.878 1.878 0 001.488-1.246l-1.463-1.463-.95 1.784h-.169z",
  fill: "#D4DAE1"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.34 13.692a.749.749 0 00.206-.496c0-.272-.097-.49-.424-.49-.326 0-.423.218-.423.49 0 .175.085.381.206.496-.26.06-.513.266-.604.786-.03.164.12.164.12.164h1.402c.006 0 .151 0 .121-.164-.085-.52-.344-.726-.604-.786z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 26.098,
  cy: 13.236,
  r: 0.531,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  x: 32.23,
  y: 12.521,
  width: 13.757,
  height: 2.307,
  rx: 1,
  fill: "#EDEEF2"
}));
var _ref11 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#auto-generated-connections_svg__filter7_d_4066_313789)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 28.73,
  y: 4.425,
  width: 35,
  height: 8.5,
  rx: 1,
  fill: "#fff",
  shapeRendering: "crispEdges"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 35.826,
  cy: 8.675,
  r: 3.135,
  fill: "#D4D7D9"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 35.855,
  cy: 8.674,
  r: 1.875,
  fill: "#E4E7EC"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M35.05 9.599l1.095.925a1.878 1.878 0 001.488-1.246l-1.464-1.464-.95 1.785h-.168z",
  fill: "#D4DAE1"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M36.067 8.692a.75.75 0 00.205-.496c0-.272-.096-.49-.423-.49-.327 0-.423.218-.423.49 0 .175.084.381.205.496-.26.06-.513.266-.604.786-.03.164.121.164.121.164h1.402c.006 0 .15 0 .12-.164-.084-.52-.343-.726-.603-.786z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 35.824,
  cy: 8.236,
  r: 0.531,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  x: 41.961,
  y: 7.521,
  width: 13.757,
  height: 2.307,
  rx: 1,
  fill: "#EDEEF2"
}));
var _ref12 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#auto-generated-connections_svg__filter8_d_4066_313789)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 18.73,
  y: 13.925,
  width: 35,
  height: 8.5,
  rx: 1,
  fill: "#fff",
  shapeRendering: "crispEdges"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 25.826,
  cy: 18.175,
  r: 3.135,
  fill: "#D4D7D9"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 25.855,
  cy: 18.174,
  r: 1.875,
  fill: "#E4E7EC"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25.05 19.099l1.095.925a1.878 1.878 0 001.488-1.246l-1.464-1.463-.95 1.784h-.168z",
  fill: "#D4DAE1"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.067 18.192a.75.75 0 00.205-.496c0-.272-.096-.49-.423-.49-.327 0-.423.218-.423.49 0 .175.084.381.205.496-.26.06-.513.266-.604.786-.03.163.121.163.121.163h1.402c.006 0 .15 0 .12-.163-.084-.52-.343-.726-.603-.786z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 25.824,
  cy: 17.736,
  r: 0.531,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  x: 31.961,
  y: 17.021,
  width: 13.757,
  height: 2.307,
  rx: 1,
  fill: "#EDEEF2"
}));
var _ref13 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#auto-generated-connections_svg__filter9_d_4066_313789)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 24,
  y: 13.925,
  width: 35,
  height: 8.5,
  rx: 1,
  fill: "#fff",
  shapeRendering: "crispEdges"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 31.096,
  cy: 18.175,
  r: 3.135,
  fill: "#D4D7D9"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 31.129,
  cy: 18.174,
  r: 1.875,
  fill: "#E4E7EC"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30.324 19.099l1.094.925a1.878 1.878 0 001.488-1.246l-1.463-1.463-.95 1.784h-.169z",
  fill: "#D4DAE1"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M31.34 18.192a.749.749 0 00.206-.496c0-.272-.097-.49-.424-.49-.326 0-.423.218-.423.49 0 .175.085.381.206.496-.26.06-.513.266-.604.786-.03.163.12.163.12.163h1.402c.006 0 .151 0 .121-.163-.085-.52-.344-.726-.604-.786z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 31.098,
  cy: 17.736,
  r: 0.531,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  x: 37.23,
  y: 17.021,
  width: 13.757,
  height: 2.307,
  rx: 1,
  fill: "#EDEEF2"
}));
var _ref14 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#auto-generated-connections_svg__filter10_d_4066_313789)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 19,
  y: 23.425,
  width: 35,
  height: 8.5,
  rx: 1,
  fill: "#fff",
  shapeRendering: "crispEdges"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 26.096,
  cy: 27.675,
  r: 3.135,
  fill: "#D4D7D9"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 26.129,
  cy: 27.674,
  r: 1.875,
  fill: "#E4E7EC"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25.324 28.599l1.094.925a1.878 1.878 0 001.488-1.246l-1.463-1.463-.95 1.784h-.169z",
  fill: "#D4DAE1"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.34 27.692a.749.749 0 00.206-.496c0-.272-.097-.49-.424-.49-.326 0-.423.218-.423.49 0 .175.085.381.206.496-.26.06-.513.266-.604.786-.03.163.12.163.12.163h1.402c.006 0 .151 0 .121-.163-.085-.52-.344-.726-.604-.786z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 26.098,
  cy: 27.236,
  r: 0.531,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  x: 32.23,
  y: 26.521,
  width: 13.757,
  height: 2.307,
  rx: 1,
  fill: "#EDEEF2"
}));
var _ref15 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#auto-generated-connections_svg__filter11_d_4066_313789)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 13.73,
  y: 18.425,
  width: 35,
  height: 8.5,
  rx: 1,
  fill: "#fff",
  shapeRendering: "crispEdges"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 20.826,
  cy: 22.675,
  r: 3.135,
  fill: "#D4D7D9"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 20.855,
  cy: 22.674,
  r: 1.875,
  fill: "#E4E7EC"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.05 23.599l1.095.925a1.878 1.878 0 001.488-1.246l-1.464-1.463-.95 1.784h-.168z",
  fill: "#D4DAE1"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.067 22.692a.75.75 0 00.205-.496c0-.272-.096-.49-.423-.49-.327 0-.423.218-.423.49 0 .175.084.381.205.496-.26.06-.513.266-.604.786-.03.163.121.163.121.163h1.402c.006 0 .15 0 .12-.163-.084-.52-.343-.726-.603-.786z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 20.824,
  cy: 22.236,
  r: 0.531,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  x: 26.961,
  y: 21.521,
  width: 13.757,
  height: 2.307,
  rx: 1,
  fill: "#EDEEF2"
}));
var _ref16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "auto-generated-connections_svg__filter0_d_4066_313789",
  x: 99.859,
  y: 3.925,
  width: 37,
  height: 10.5,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.5,
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4066_313789"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4066_313789",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "auto-generated-connections_svg__filter1_d_4066_313789",
  x: 99.59,
  y: 3.925,
  width: 37,
  height: 10.5,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.5,
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4066_313789"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4066_313789",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "auto-generated-connections_svg__filter2_d_4066_313789",
  x: 99.59,
  y: 13.425,
  width: 37,
  height: 10.5,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.5,
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4066_313789"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4066_313789",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "auto-generated-connections_svg__filter3_d_4066_313789",
  x: 99.859,
  y: 22.925,
  width: 37,
  height: 10.5,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.5,
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4066_313789"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4066_313789",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "auto-generated-connections_svg__filter4_d_4066_313789",
  x: 94.859,
  y: 17.77,
  width: 47,
  height: 12.929,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.5,
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4066_313789"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4066_313789",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "auto-generated-connections_svg__filter5_d_4066_313789",
  x: 94.859,
  y: 5.888,
  width: 47,
  height: 12.929,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.5,
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4066_313789"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4066_313789",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "auto-generated-connections_svg__filter6_d_4066_313789",
  x: 18,
  y: 9.425,
  width: 39,
  height: 12.5,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 1,
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4066_313789"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4066_313789",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "auto-generated-connections_svg__filter7_d_4066_313789",
  x: 27.73,
  y: 4.425,
  width: 39,
  height: 12.5,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 1,
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4066_313789"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4066_313789",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "auto-generated-connections_svg__filter8_d_4066_313789",
  x: 17.73,
  y: 13.925,
  width: 39,
  height: 12.5,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 1,
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4066_313789"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4066_313789",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "auto-generated-connections_svg__filter9_d_4066_313789",
  x: 23,
  y: 13.925,
  width: 39,
  height: 12.5,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 1,
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4066_313789"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4066_313789",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "auto-generated-connections_svg__filter10_d_4066_313789",
  x: 18,
  y: 23.425,
  width: 39,
  height: 12.5,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 1,
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4066_313789"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4066_313789",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "auto-generated-connections_svg__filter11_d_4066_313789",
  x: 12.73,
  y: 18.425,
  width: 39,
  height: 12.5,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 1,
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4066_313789"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4066_313789",
  result: "shape"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "auto-generated-connections_svg__clip0_4066_313789"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(117.188 15.344)",
  d: "M0 0h4v4H0z"
})));
function SvgAutoGeneratedConnections(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 155 36",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}
export default __webpack_public_path__ + "fonts/auto-generated-connections-4d303ce4a85b01c2b4e492c00c335f2d.svg";
export { SvgAutoGeneratedConnections as ReactComponent };